import { useaxios } from "../../../utils/useaxios";
export default (from, to, invoice_id, item_barcode) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('sell_invoice/read.php', { from, to, invoice_id, item_barcode }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setsellinvoice', payload: res.today_invoice })
            // setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}